module.exports = __webpack_public_path__ + "assets/img/tedian6.a37be9f8.png";